import React, { useCallback, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SOUND_NAME } from "../../../../sounds";
import PopupWindow from "../Displays/PopupWindow";
import Overlay from "../../../../Games/Shared/Overlay/Overlay";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { soundManager } from "../../../../SoundManager";

const ExpirationPopup = () => {
  const { t } = useTranslation();
  const { expirationPopupActive } = useSelector((state) => state.userInterface);
  const overlayRef = useRef(null);
  const windowRef = useRef(null);
  const { dimensions } = useDimensions();

  const popupText = t("session_expired");

  useEffect(() => {
    if (expirationPopupActive && overlayRef.current) {
      overlayRef.current.fadeInBackground();
    }
  }, [expirationPopupActive]);

  const handleReload = useCallback(() => {
    soundManager.play(SOUND_NAME.button_click);
    window.location.reload();
  }, []);

  if (!expirationPopupActive) {
    return null;
  }

  return (
    <>
      <Overlay
        ref={overlayRef}
        dimensions={dimensions}
        interactive={false}
        fadeDuration={200}
      />

      <PopupWindow
        ref={windowRef}
        name="primary_expiration_popup"
        fadeDuration={200}
        showButtons={true}
        onYesClick={handleReload}
        showCloseButton={false}
      >
        {popupText}
      </PopupWindow>
    </>
  );
};

export default ExpirationPopup;
